<template>
  <div class="without-access">
    <h1 data-test="access-denied">
      Acesso não permitido
    </h1>
    <p>
      Você precisa ser convidado pelo seu gerente de contas para acessar.
      <br>Caso o problema persista, entre em contato com o suporte.
    </p>
  </div>
</template>

<script>
export default {
  name: 'WithoutAccessToBenchmarks',
};
</script>

<style lang="scss" scoped>
  .without-access {
    display: flex;
    height: 85vh;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }

  h1 {
    font-family: var(--ds-font-family-base);
    font-weight: var(--ds-font-weight-semibold);
    font-size: var(--ds-font-size-xl);
    color: var(--ds-color-text-dark);
  }

  p {
    font-family: var(--ds-font-family-base);
    font-size: var(--ds-font-size-sm);
    text-align: center;
    color: var(--ds-color-text-2);
  }
</style>
